import { useStages } from '@/features/admin/stages/hooks'
import { useContractGate } from '../gating/hooks'
import { GateRequirementsPanel } from '../gating/components/GateRequirementsPanel'
import { CompleteStageButton } from './CompleteStageButton'
import { OverrideStageButton } from './OverrideStageButton'
import type { Contract } from '../types'

type Props = {
  contract: Contract
  onCancel?: () => void
}

export function TaskSidebar({ contract, onCancel }: Props) {
  const stagesQ = useStages(contract.configurationCode)
  const currentStage = stagesQ.data?.find(s => s.code === contract.currentStageCode)
  const stageLabel = currentStage?.labelPl ?? contract.currentStageCode
  const isTerminal = currentStage?.isTerminal ?? false
  const gateQ = useContractGate(contract.id)
  const gateClosed = gateQ.data ? !gateQ.data.canComplete : false

  return (
    <div className="p-4 flex flex-col gap-4 text-sm border-b border-slate-200">
      <div>
        <div className="text-[10px] uppercase tracking-wide text-slate-500 mb-1">Etap aktualny</div>
        <span
          className="inline-block rounded bg-emerald-600 text-white text-xs px-2 py-0.5 font-medium"
          title={contract.currentStageCode}
        >
          {stageLabel}
        </span>
      </div>

      <GateRequirementsPanel contractId={contract.id} />

      <div>
        <CompleteStageButton
          contractId={contract.id}
          nextStage={contract.nextStage}
          disabled={isTerminal || gateClosed}
          gateClosed={gateClosed}
        />
      </div>

      <div className="flex flex-col gap-2">
        <OverrideStageButton
          contractId={contract.id}
          configurationCode={contract.configurationCode}
          currentStageCode={contract.currentStageCode}
        />
        <button
          type="button"
          disabled={!onCancel || isTerminal}
          onClick={onCancel}
          className="w-full rounded border border-red-600 text-red-600 px-2 py-1 text-xs disabled:opacity-50"
        >
          Anuluj umowę
        </button>
      </div>
    </div>
  )
}
